export default __webpack_public_path__ + "static/media/banner-smiles.70a5a801.png";